// extracted by mini-css-extract-plugin
export var container = "my-subscriptions-module--container--5a7db";
export var deleteButton = "my-subscriptions-module--delete-button--02ef1";
export var link = "my-subscriptions-module--link--90e12";
export var list = "my-subscriptions-module--list--e5f71";
export var noSubscriptionHeader = "my-subscriptions-module--no-subscription-header--8b3fb";
export var noSubscriptionText = "my-subscriptions-module--no-subscription-text--e2c51";
export var title = "my-subscriptions-module--title--ffb5d";